import React from "react";

import { faLightbulb } from "@fortawesome/pro-solid-svg-icons/faLightbulb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import Deal from "@mapmycustomers/shared/types/entity/Deal";

import BoardColumn from "@app/component/DnDBoard/types/BoardColumn";
import localSettings from "@app/config/LocalSettings";
import AdjustedAmountTooltip from "@app/scene/deal/component/AdjustedAmountTooltip";
import DateColumn from "@app/scene/deal/type/DateColumn";

import styles from "./ColumnSummaryInfo.module.scss";

interface Props {
  column: BoardColumn<DateColumn, Deal>;
}

const ColumnSummaryInfo: React.FC<Props> = ({ column }) => {
  const intl = useIntl();

  const { adjustedAmount, amount } = column.data;

  return (
    <div className={styles.container}>
      <div className={styles.money}>
        <div className={styles.openAmount}>
          {intl.formatNumber(amount ?? 0, {
            currency: localSettings.getCurrencyCode(),
            minimumFractionDigits: 0,
            style: "currency",
          })}
        </div>
        <AdjustedAmountTooltip>
          <div className={styles.adjustedAmount}>
            <FontAwesomeIcon icon={faLightbulb} />
            <span>
              {intl.formatMessage(
                {
                  id: "deals.forecastView.column.adjustedAmount",
                  defaultMessage: "{value} adjusted",
                  description: "Adjusted Amount value of subheader on Deal forecast page",
                },
                {
                  value: intl.formatNumber(adjustedAmount ?? 0, {
                    currency: localSettings.getCurrencyCode(),
                    minimumFractionDigits: 0,
                    style: "currency",
                  }),
                }
              )}
            </span>
          </div>
        </AdjustedAmountTooltip>
      </div>
    </div>
  );
};

export default ColumnSummaryInfo;
